import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PopupComp, ContactCard } from '../index';
import { ROUTES } from '../../constants';

const SupportCTA = ({ title, description }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.user);
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      {/* The Popup Logic */}
      {showPopup && (
        <PopupComp onClose={() => setShowPopup(false)}>
          <ContactCard onClose={() => setShowPopup(false)} />
        </PopupComp>
      )}

      {/* The UI Box */}
      <div className='relative overflow-hidden bg-gradient-to-br from-gray-900 to-blue-900 rounded-[2.5rem] p-10 sm:p-16 text-center shadow-2xl my-10'>
        {/* Decorative Background Glow */}
        <div className="absolute top-0 right-0 -translate-y-12 translate-x-12 w-64 h-64 bg-blue-500 rounded-full opacity-10 blur-3xl"></div>
        
        <div className='relative z-10 space-y-6'>
          <h2 className='text-2xl sm:text-3xl font-black text-white'>
            {title || (isAuthenticated ? "Still have questions?" : "Help us Improve!")}
          </h2>
          
          <p className='text-blue-100/70 text-lg max-w-md mx-auto'>
            {description || (isAuthenticated 
              ? "Our team of seniors is here to guide you through your placement journey." 
              : "Found a bug or have a suggestion? We'd love to hear from you.")}
          </p>

          <div className='flex flex-wrap justify-center gap-4'>
            {isAuthenticated ? (
              <button
                onClick={() => setShowPopup(true)}
                className='px-10 py-4 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-2xl transition-all shadow-lg active:scale-95'
              >
                Ask a Senior
              </button>
            ) : (
              <button
                onClick={() => navigate(ROUTES.help)}
                className='px-8 py-4 bg-white/10 hover:bg-white/20 text-white border border-white/20 font-bold rounded-2xl transition-all backdrop-blur-md'
              >
                Report a Bug / Suggestion
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SupportCTA;